import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updatePassword } from '../api/AUTH/auth';
import { toast } from 'react-toastify';

export const useUpdatePassword = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updatePassword,
    onSuccess: (data) => {
      toast.success('Mot de passe modifié avec succès', {
        autoClose: 3000,
        hideProgressBar: true,
        pauseOnHover: true,
      });
      queryClient.invalidateQueries({ queryKey: ['currentUser'] });
    },
    onError: (error) => {
      toast.error(error.message || 'Erreur lors de la mise à jour du mot de passe', {
        autoClose: 3000,
        hideProgressBar: true,
        pauseOnHover: true,
      });
    },
  });
};
